var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWarningIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0V0C18.6274 0 24 5.37258 24 12V12C24 18.6274 18.6274 24 12 24V24C5.37258 24 0 18.6274 0 12V12Z",
    fill: "#FA6B63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.2513V12.2509M12 14.2504H12.0058M11.1905 7.69777L6.38225 14.7994C6.11555 15.1934 5.9822 15.3903 6.00191 15.552C6.0191 15.6929 6.10549 15.8211 6.23957 15.9044C6.39329 16 6.65944 16 7.19173 16H16.8083C17.3406 16 17.6067 16 17.7604 15.9044C17.8945 15.8211 17.9809 15.6929 17.9981 15.552C18.0178 15.3903 17.8845 15.1934 17.6178 14.7994L12.8095 7.69777C12.5437 7.30528 12.4109 7.10903 12.2375 7.04312C12.0863 6.98563 11.9137 6.98563 11.7625 7.04312C11.5891 7.10903 11.4563 7.30528 11.1905 7.69777Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarningIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warningIcon.27f1de5b.svg";
export { ForwardRef as ReactComponent };